import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PartnerTier, PartnerType } from "@colab/shared";

// GET /api/portal/partner — the viewing partner's identity row. For internal
// preview-as the worker rewrites session.partnerId, so the response always
// mirrors what the previewed partner would see.
export type CurrentPartner = {
  id: string;
  company_name: string;
  partner_type: PartnerType;
  tier: PartnerTier;
  status: string;
  primary_contact_name: string | null;
  primary_contact_email: string | null;
  website: string | null;
  region: string | null;
  notes: string | null;
  assigned_owner: string | null;
  integrates_with: string[];
  rewards_pending_eur: number | null;
  rewards_paid_eur: number | null;
  hubspot_partner_record_id: string | null;
  hubspot_company_id: string | null;
  created_at: string;
  updated_at: string;
};

export function useCurrentPartner() {
  return useQuery<CurrentPartner, ApiClientError>({
    queryKey: queryKeys.portal.partner(),
    queryFn: () => apiFetch<CurrentPartner>("/portal/partner"),
  });
}
